export default "__VITE_ASSET__B30$$gWn__"